import useProtoMethod from "./useProtoMethod";
import {
  AdminListReviewsRequest,
  AdminListReviewsResponse,
  CreateReviewRequest,
  CreateReviewResponse,
  ListReviewsRequest,
  ListReviewsResponse,
  UpdateReviewRequest,
  UpdateReviewResponse,
} from "protogen/review_service_pb";

const useCreateReview = (callback?: (r: CreateReviewResponse) => void) => {
  return useProtoMethod<CreateReviewRequest, CreateReviewResponse>(
    "CreateReview",
    CreateReviewResponse,
    { callback },
  );
};

const useListReviews = (callback?: (r: ListReviewsResponse) => void) => {
  return useProtoMethod<ListReviewsRequest, ListReviewsResponse>(
    "ListReviews",
    ListReviewsResponse,
    { callback },
  );
};

const useAdminListReviews = (
  callback?: (r: AdminListReviewsResponse) => void,
) => {
  return useProtoMethod<AdminListReviewsRequest, AdminListReviewsResponse>(
    "AdminListReviews",
    AdminListReviewsResponse,
    { callback },
  );
};

const useUpdateReview = (callback?: (r: UpdateReviewResponse) => void) => {
  return useProtoMethod<UpdateReviewRequest, UpdateReviewResponse>(
    "UpdateReview",
    UpdateReviewResponse,
    { callback },
  );
};

export {
  useAdminListReviews,
  useCreateReview,
  useListReviews,
  useUpdateReview,
};
